<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentPayments /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentPayments from '@/components/worker/dashboard/modules/report/payments/ContentPayments.vue'

export default 
{
  name: 'Payments',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentPayments
  }
}
</script>

<style>

</style>